export const types = ['primary', 'secondary', 'outlined', 'clear'];
export const sizeClasses = ['xlarge', 'large', 'medium', 'small', 'xsmall'];
export const textTransform = 'uppercase';
export const fontWeight = 700;
export const borderWidth = '1px';
export const borderRadius = '4px';

export const backgroundColors = {
  primary: '#1D4ED8',
  secondary: '#F7CE46',
  outlined: 'unset',
  clear: 'unset',
};

export const fontColors = {
  primary: '#FFFFFF',
  secondary: '#000000',
  outlined: '#1D4ED8',
  clear: '#1D4ED8',
};

export const hoverBackgroundColors = {
  primary: '#173EAD',
  secondary: '#C6A538',
  outlined: '#E8EDFB',
  clear: '#E8EDFB',
};

export const focusBackgroundColors = {
  primary: '#112F82',
  secondary: '#947C2A',
  outlined: '#BBCAF3',
  clear: '#BBCAF3',
};

export const borderColors = {
  primary: '#1D4ED8',
  secondary: '#F7CE46',
  outlined: '#1D4ED8',
  clear: 'rgba(0,0,0,0)',
};

export const hoverBorderColors = {
  primary: '#173EAD',
  secondary: '#C6A538',
  outlined: '#1D4ED8',
  clear: '#E8EDFB',
};

export const focusBorderColors = {
  primary: '#112F82',
  secondary: '#947C2A',
  outlined: '#1D4ED8',
  clear: '#BBCAF3',
};

export const paddings = {
  xlarge: '1.6rem',
  large: '1.2rem',
  medium: '0.8rem 1rem',
  small: '0.8rem',
  xsmall: '0.4rem 0.8rem',
};

export const fontSizes = {
  xlarge: '1.6rem',
  large: '1.6rem',
  medium: '1.4rem',
  small: '1.2rem',
  xsmall: '1rem',
};

export const lineHeights = {
  xlarge: '2.4rem',
  large: '2.4rem',
  medium: '2.4rem',
  small: '1.6rem',
  xsmall: '1.6rem',
};
